module.exports = __webpack_public_path__ + "assets/f1d361dca8d696fdd093bb645f468002.mp3";